import moment from 'moment'

export const Customer = {
    id: '',
    name: '',
    address: '',
    email: '',
    phone: '',
    remark: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}